import type { IInstructionsProps } from "../../types";
import { Button, Dialog, Typography, DialogTitle, DialogActions, Box } from "@mui/material";

export default function Instructions(props: IInstructionsProps) {
  const { isDialogOpen, selfie, document, text, disabled, isGreeted, styles, handleCloseDialog, attempts } = props;

  return (
    <>
      <Dialog
        open={isDialogOpen}
        PaperProps={{
          sx: {
            ...styles.dialogBase,
            justifyContent: isGreeted ? "space-between" : "center",
            backgroundImage: !isGreeted
              ? ""
              : selfie
              ? document
                ? "url(/images/backID.jpg)"
                : "url(/images/frontID.jpg)"
              : "url(/images/faceFrame.jpg)",
          },
        }}
      >
        <DialogTitle sx={styles.dialogTitle}>
          <Typography sx={styles.dialogText}>
            {!isGreeted ? (
              text.welcome
            ) : selfie ? (
              document ? (
                text.TakePhotoBackSide
              ) : (
                text.TakePhotoDocument
              )
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <span>{text.frameFaceOval}</span>
                <span
                  style={{
                    direction: text.language === "hebrew" ? "rtl" : "ltr",
                  }}
                >
                  {attempts + 1 + " " + text.of_3_attempts}
                </span>
              </Box>
            )}
          </Typography>

          <Typography sx={styles.dialogText}>
            {!isGreeted ? "" : selfie ? (document ? text.FrameBackSide : text.FrameDocument) : ""}
          </Typography>
        </DialogTitle>

        {isGreeted ? null : (
          <DialogTitle sx={styles.dialogTitle}>
            <Typography sx={styles.dialogText}>{text.followInstructions}</Typography>
          </DialogTitle>
        )}

        <DialogActions sx={styles.dialogActions}>
          <Button
            onClick={handleCloseDialog}
            disabled={disabled}
            variant="contained"
            sx={styles.continue}
            id="continue"
          >
            {text.continue}
          </Button>

          <Typography sx={styles.dialogCaption}>{selfie ? (document ? text.docBack : text.nextStep) : null}</Typography>
        </DialogActions>
      </Dialog>
    </>
  );
}
